<template>
	<div class="stream-stats">
		<div class="one">
			<div class="total-user">
				<p>Общее число абонентов:</p>
				<p class="green">{{getTotalUsers}}</p>
			</div>
			<div class="online-user">
				<p>Абоненты онлайн:</p>
				<p class="green">{{onlineUser}}</p>
			</div>
			<div class="offline-user">
				<p>Абоненты оффлайн:</p>
				<p class="red">{{getOfflineUser}}</p>
			</div>
		</div>
		<div class="two">
			<div class="total-streams">
				<p>Общее число каналов:</p>
				<p class="green">{{getTotalStreams}}</p>
			</div>
			<div class="offline-streams">
				<p>Каналы оффлайн</p>
				<p class="red">{{getOfflineStreams}}</p>
			</div>
			<div class="archive">
				<p>Количество TV-архива:</p>
				<p class="green">достаточно</p>
			</div>
		</div>
	</div>
</template>
<script>
	import { mapGetters, mapMutations } from "vuex";
	import { performRequest }           from "../script/ws/wsclient";
	import _                            from "lodash";

	export default {
		name:     "StreamStats",
		data() {
			return {
				command:    {},
				onlineUser: ""
			};
		},
		mounted() {
			this.getUserStat();
		},
		computed: {
			...mapGetters(["getStreams", "getAutocomplete", "getViewUser"]),
			getTotalStreams() {
				return this.getStreams.length;
			},
			getOfflineStreams() {
				let offlineStream = _.filter(this.getStreams, { online: 0 });
				this.setOfflineStreams(offlineStream);
				return offlineStream.length;
			},
			getTotalUsers() {
				return this.getAutocomplete.length;
			},
			getOfflineUser() {
				return this.getTotalUsers - this.onlineUser;
			}
		},
		methods:  {
			...mapMutations(["setOfflineStreams"]),
			getUserStat() {
				this.command.section = "iptvlog";
				this.command.name    = "getActiveUserList";
				performRequest(this.command, { operator: this.getViewUser }, a => {
					this.onlineUser = a.data.length;
				});
			}
		}
	};
</script>
<style scoped lang="scss">
	.stream-stats {
		display: flex;
		width: 45rem;
		min-width: 41rem;
		justify-content: space-between;
		padding: 0.1rem;
		margin: 0.5rem;
		background-color: rgba(184, 200, 209, 0.5);
		border-radius: 0.2rem;
		height: 8.5rem;
		box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.43);
		
		.one, .two {
			padding: 1rem;
			margin: 0.2rem;
			width: 50%;
			min-width: 20rem;
			border-radius: 0.2rem;
			
			div {
				display: flex;
				justify-content: space-between;
				
				p:last-child {
					margin-left: 1rem;
				}
				
				p {
					margin: 0.2rem;
				}
				
				.green {
					color: #156b15;
				}
				
				.red {
					color: #ff2c2e;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/StreamStats.vue